import { Flex } from '@chakra-ui/react';
import { FormFeedback, Input, OutlineCard } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import {
  FormFieldIPEMMembership,
  FormFieldTextInput
} from '@publishing-engine/domain/types/article';
import { get } from 'lodash';
import asDependentFieldComponent from './asDependentFieldComponent';

const TextInput = ({
  config,
  placeholder
}: {
  config:
    | FormFieldIPEMMembership
    | FormFieldTextInput<
        | 'preference.openAccessChoiceWorldBankACountry'
        | 'preference.openAccessChoiceWorldBankBCountry'
        | 'preference.openAccessChoiceReviewerDiscountRate'
      >
    | null;
  placeholder: string;
}) => {
  const {
    formState: { errors },
    register,
    watch
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main }
  } = config!;
  const error = get(errors, main);
  const value = watch(main);

  return (
    <OutlineCard borderless padding={8} width={'100%'}>
      <Flex flexDirection="column" gap={4}>
        <FieldLabel
          isRequired={validations.required}
          label={labels.main}
          subText={labels.subtitle}
          helpText={labels.helpText}
        />
        <Input
          placeholder={placeholder}
          value={value}
          isInvalid={Boolean(error)}
          {...register(main)}
        />
      </Flex>
      {error && (
        <FormFeedback variant="error">
          {error.type === 'required' && `${labels.main} is required`}
          {error.type === 'maxLength' &&
            `Maximum length is ${validations.maxLength} characters`}
          {error.type === 'minLength'
            ? `Please enter a ${labels.main}`
            : `Maximum length is ${validations.maxLength} characters`}
        </FormFeedback>
      )}
    </OutlineCard>
  );
};

export default asDependentFieldComponent(TextInput);
